export default __webpack_public_path__ + "static/media/requiere_factura.2963775c.svg";